import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { IImportedMediaItem } from './types';

const importFacebook = createAsyncAction(
  'MEDIA_IMPORT/FACEBOOK_REQUEST',
  'MEDIA_IMPORT/FACEBOOK_SUCCESS',
  'MEDIA_IMPORT/FACEBOOK_FAIL',
)<string, IImportedMediaItem[], Error>();

const importSite = createAsyncAction(
  'MEDIA_IMPORT/SITE_REQUEST',
  'MEDIA_IMPORT/SITE_SUCCESS',
  'MEDIA_IMPORT/SITE_FAIL',
)<string, IImportedMediaItem[], Error>();

const storeFacebookUrl = createStandardAction(
  'MEDIA_IMPORT/FACEBOOK_URL',
)<string>();

const storeSiteUrl = createStandardAction('MEDIA_IMPORT/SITE_URL')<string>();

const toggleSelected = createStandardAction('MEDIA_IMPORT/TOGGLE_SELECTED')<{
  url: string;
  selected: boolean;
}>();

const preselectImportedMedia = createStandardAction('MEDIA_IMPORT/PRESELECT')<
  string[]
>();

const clearFacebookMedia = createStandardAction(
  'MEDIA_IMPORT/FACEBOOK_CLEAR',
)();

const clearSiteMedia = createStandardAction('MEDIA_IMPORT/SITE_CLEAR')();

const toggleImportNotification = createStandardAction(
  'MEDIA_IMPORT/TOGGLE_NOTIFICATION',
)<boolean>();

export {
  importFacebook,
  importSite,
  toggleSelected,
  preselectImportedMedia,
  storeFacebookUrl,
  storeSiteUrl,
  clearFacebookMedia,
  clearSiteMedia,
  toggleImportNotification,
};
